import {
    UserIconComponent as SourceUserIconComponent,
} from 'SourceComponent/UserIcon/UserIcon.component';
import {ReactElement} from 'Type/Common.type';

import './UserIcon.override.style';

/** @namespace Steinkrueger/Component/UserIcon/Component */
export class UserIconComponent extends SourceUserIconComponent {
    render(): ReactElement {
        const { isActive } = this.props;

        return (
            <svg
              block="UserIcon"
              mods={ { isActive } }
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="28"
              viewBox="0 0 29 28"
              fill="none"
            >
                <path
                  d="M14.5 0.5C7.05607 0.5 1 6.55607 1 14C1 21.4439 7.05607
                  27.5 14.5 27.5C21.9439 27.5 28 21.4439 28 14C28 6.55607 21.9439
                  0.5 14.5 0.5ZM14.5 25.918C11.0314 25.918 7.78502 24.4333 5.51517
                  21.827C6.69078 19.6673 9.62882 16.4855 14.5 16.4855C19.3769 16.4855
                  22.3128 19.6738 23.4848 21.827C21.215 24.4333 17.9686 25.918 14.5
                  25.918ZM10.2074 10.6109C10.2074 8.24399 12.1331 6.31834 14.5 6.31834C16.867
                  6.31834 18.7926 8.24399 18.7926 10.6109C18.7926 12.9778 16.8669 14.9035
                  14.5 14.9035C12.1331 14.9035 10.2074 12.9779 10.2074 10.6109ZM17.8975
                  15.4009C19.3956 14.3353 20.3746 12.5853 20.3746 10.6109C20.3746
                  7.37166 17.7393 4.73631 14.5 4.73631C11.2607 4.73631 8.62539
                  7.37166 8.62539 10.6109C8.62539 12.5853 9.6044 14.3352
                  11.1025 15.4009C7.99073 16.3342 5.80684 18.3545 4.48701 20.4566C3.28234
                  18.5949 2.58203 16.3778 2.58203 14C2.58203 7.4284 7.9284 2.08203 14.5
                  2.08203C21.0716 2.08203 26.418 7.4284 26.418 14C26.418 16.3778
                  25.7177 18.5949 24.5129 20.4567C23.1913 18.3519 21.0056 16.3331
                  17.8975 15.4009Z"
                  strokeWidth="0.5"
                />
            </svg>
        );
    }
}

export default UserIconComponent;
